import { Component, DestroyRef, ElementRef, inject, ViewChild } from '@angular/core';
import { UserDTO } from 'src/app/models/UserDTO.model';
import { CustomerService } from 'src/app/services/customer.service';
import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { ValidatePermissionsService } from 'src/app/shared/services/validate-permissions.service';
import { Alert } from 'src/app/shared/models/Alert';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ResponseDataFile } from 'src/app/shared/models/ApiResponse';
import { saveAs } from 'file-saver';
import { PaginationService } from 'src/app/shared/services/pagination.service';
import { finalize, map, of, Subject, switchMap, takeUntil, tap } from 'rxjs';
import { FindCustomerPlanResultDTO } from '../../../models/FindCustomerPlanResultDTO.model';
import { PlanByUserDTO } from '../../../models/PlanByUserDTO.model';
import { DataInputPlanDevices } from '../../../models/DataInputPlanDevices.model';

import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CreateCustomerComponent } from '../create-customer/create-customer.component';
import { TooltipDirective } from '../../../directives/tooltip.directive';
import { SearchPipe } from '../../../pipes/search.pipe';
declare var bootstrap: any;

@Component({
    selector: 'app-list-customers',
    templateUrl: './list-customers.component.html',
    styleUrls: ['./list-customers.component.css'],
    imports: [
        CommonModule,
        FormsModule,
        CreateCustomerComponent,
        TooltipDirective,
        SearchPipe
    ]
})
export class ListCustomersComponent {
  
  customers: UserDTO[] = [];
  filteredCustomers: any[] = [];
  textoBusqueda: string = '';
  textToSearchICCID: string = '';

  camposBusqueda: string[] = [
    'userId',
    'userNames',
    'userMail',
    'userPhone',
    'numberPlans',
    'numberDevices',
  ];
  isFilteredByStatus: boolean = false;
  originalCustomers: any[] = [];
  selectedCustomer: any;
  alert: Alert = {} as Alert;

  constructor(
    private customerService: CustomerService,
    private router: Router,
    private route: ActivatedRoute,
    private alertService: AlertService,
    public permissionsService: ValidatePermissionsService,
    public paginationService: PaginationService
  ) { }

  ngOnInit() {
    
    this.permissionsService.validateAccessLevels(MODULE_ID.Customers);

    this.customerService.getListCustomers().subscribe(
      ({ StatusCode, Message, Data }) => {
        if (Data != null) {
          this.HandleGetListCustomers(Data);
        } else {
          this.HandleGetListCustomersError(StatusCode);
        }
      },
      (error) => {
        this.alert = {
          alertMessage: 'Unexpected error. Please try again later.',
          alertType: 'alert alert-danger',
          alertCenter: false,
          alerTitle: '',
          duration: 3000
        };
        this.alertService.updateAlertState(
          this.alert
        );
      }
    );
  }


  closeModal(): void {
    const modalElement = document.getElementById('configurationsModal');
    if (modalElement) {
      const modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (modalInstance) {
        modalInstance.hide(); // Cerrar el modal
      }
    }

    // Asegurarse de que el fondo oscuro (backdrop) se elimina
    const modalBackdrop = document.querySelector('.modal-backdrop');
    if (modalBackdrop) {
      modalBackdrop.remove(); // Remover el fondo oscuro manualmente
    }

    // También asegurarnos de que se elimine la clase `modal-open` del body
    document.body.classList.remove('modal-open');
  }


  get pages(): number[] {
    return this.paginationService.pages;
  }

  changePage(page: number) {
    this.paginationService.changePage(page);
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  previousPage() {
    this.paginationService.previousPage();
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  nextPage() {
    this.paginationService.nextPage(this.filteredCustomers.length);
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  getRange(): string {
    return this.paginationService.getRange(this.filteredCustomers.length);
  }

  HandleGetListCustomersError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  HandleGetListCustomers(customerList: UserDTO[]) {
    // Guarda la lista de clientes original
    this.customers = customerList;
    this.originalCustomers = this.customers.slice();
    this.customers = this.originalCustomers.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
    // Llama al servicio para filtrar y paginar los datos
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );

    // Reinicia la paginación a la primera página
    this.paginationService.currentPage = 1;
  }

  onSearchChange(): void {
    this.paginationService.currentPage = 1;
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  filterByStatus(status: number) {
    this.customers = this.originalCustomers.slice();
    if (!this.isFilteredByStatus) {
      this.originalCustomers = this.customers.slice();
      this.isFilteredByStatus = true;
    }

    this.customers = this.originalCustomers.filter(
      (customer) => customer.userStatus === status
    );

    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  clearFilter() {
    this.isFilteredByStatus = false;
    this.customers = this.originalCustomers.slice();
    this.customers = this.customers.filter(
      (user) => user.userStatus === 0 || user.userStatus === 1
    );
    this.filteredCustomers = this.paginationService.updatePagination(
      this.customers, this.textoBusqueda, this.camposBusqueda
    );
  }

  setSelectedCustomer(customer: any) {
    this.selectedCustomer = customer;
  }

  setArchivedCustomer(customer: any) {
    this.selectedCustomer = customer;
    this.selectedCustomer['@userStatus'] = this.selectedCustomer.userStatus === 2 ? 1 : 2;
  }

  toggleStatus(event: any, customer: any) {
    customer.userStatus = event.target.checked ? 1 : 0;
    const indice = this.originalCustomers.findIndex(
      (cust) => cust.userId === customer.userId
    );
    if (indice !== -1) {
      this.originalCustomers[indice].userStatus = customer.userStatus;
    }
  }

  openConfirmationModal(customer: any) {
    this.selectedCustomer = customer;
  }

  public updateUserStatus(confirmed: boolean) {
    
    if (confirmed) {
      if (typeof this.selectedCustomer['@userStatus'] === 'number') this.selectedCustomer.userStatus = this.selectedCustomer['@userStatus'];
      this.customerService
        .updateCustomerStatus(this.selectedCustomer)
        .subscribe(
          ({ StatusCode, Message, Data }) => {
            if (Data != null) {
              this.HandleUpdateCustomerStatus(Data);
            } else {
              this.HandleUpdateCustomerStatusError(StatusCode);
            }
          },
          (error) => {
            this.alert = {
              alertMessage: 'Unexpected error. Please try again later.',
              alertType: 'alert alert-danger',
              alertCenter: false,
              alerTitle: '',
              duration: 3000
            };
            this.alertService.updateAlertState(
              this.alert
            );
          }
        );
    } else {
      location.reload();
    }
  }

  HandleUpdateCustomerStatusError(StatusCode: number) {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  async HandleUpdateCustomerStatus(customer: boolean) {
    this.alert = {
      alertMessage: 'Customer status updated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
    location.reload();
  }

  navigateToCustomerPlans(customer?: UserDTO | number) {
    this.closeModal();
    customer && of(customer).pipe(
      switchMap(x =>
        typeof x === 'number'
          ? this.customerService.getCustomerById({ userId: x }).pipe(map(x => x.Data))
          : of(x)
      ),
      tap(c => {
        this.router.navigate(['/customers/customer-plans'], {
          relativeTo: this.route,
          state: { customerData: c },
        });
      })
    )
    .subscribe();
  }

  navigateToCustomerUsers(customer: any) {
    this.closeModal();
    this.router.navigate(['/customers/customer-users', customer.userId], {
      relativeTo: this.route,

    });
  }

  navigateToICCID(iccid?: string) {
    this.closeModal();
    iccid && this.router.navigate(['/inventory/inventory-update', iccid], {
      relativeTo: this.route
    });
  }

  navigateToCustomerPlanDevices(plan?: DataInputPlanDevices | FindCustomerPlanResultDTO | any) {
    this.closeModal();
    if (!plan) return;
    let dataInputPlanDevice;
    if (typeof plan.userId === 'number' && typeof plan.userPlanId === 'number') {
      dataInputPlanDevice = {
        customerId: plan.userId,
        customerName: plan.userName,
        planID: plan.userPlanId,
        planName: plan.planName
      };
    }
    else {
      dataInputPlanDevice = <DataInputPlanDevices>plan;
    }

    this.router.navigate(['/customers/plan-devices'], {
      relativeTo: this.route,
      state: {
        dataInputPlanDevice
      }
    });
  }



  goBack() {
    window.location.href = '/home';
  }

  navigateToCustomerView(customer: any) {
    this.closeModal();
    this.router.navigate(['/customers/view-customer/', customer.userId]);
  }

  navigateToCustomerAccount(customer: any) {
    this.closeModal();
    this.router.navigate(['/customers/customer-account/', customer.userId]);
  }

  exportCustomerListToExcel() {
    this.customerService.exportCustomersListToExcel().subscribe(
      (response: ResponseDataFile) => {
        if (response) {
          this.handleDownload(response);
        } else {
          this.handleGetListCustomersError();
        }
      },
      (error) => {
        console.error('Error al exportar el archivo Excel:', error);
      }
    );
  }

  private handleDownload(data: ResponseDataFile) {
    const byteCharacters = atob(data.Data.fileContents);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: data.Data.contentType });
    saveAs(blob, data.Data.fileDownloadName || 'export.xlsx');

    this.alert = {
      alertMessage: 'File generated successfully',
      alertType: 'alert alert-success',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    localStorage.setItem('AlertObject', JSON.stringify(this.alert));
    this.alertService.updateAlertState(
      this.alert
    );
  }

  private handleGetListCustomersError() {
    this.alert = {
      alertMessage: 'Unexpected error. Please try again later.',
      alertType: 'alert alert-danger',
      alertCenter: false,
      alerTitle: '',
      duration: 3000
    };
    this.alertService.updateAlertState(
      this.alert
    );
  }

  @ViewChild('modalSearchICCDRef') modalSearchICCDRef?: ElementRef<HTMLDivElement>;

  searchResult?: FindCustomerPlanResultDTO | null;

  searchICCID(): void {
    this.router.navigate(['/simSearch'], {
      //queryParams: { s: this.textToSearchICCID },
      state: { searchText: this.textToSearchICCID }
    });
    this.textToSearchICCID = '';
/*
    this.customerService.findCustomerPlanByICCID(this.textToSearchICCID)
      .subscribe({
        next: response => {
          this.searchResult = response;
          if (this.modalSearchICCDRef) {
            const modalInstance = bootstrap.Modal.getOrCreateInstance(this.modalSearchICCDRef.nativeElement);
            modalInstance.show();
          }
        },
        error: e => console.error('Error when find customer plan by ICCID:', e)
      });
*/
  }
}
